import React, { useState } from 'react';

import CharacterItem from './CharacterItem';
import { Link } from 'react-router-dom';
import Message from '../../components/message/Message';
import PropTypes from 'prop-types';
import SafeHtml from 'epic-react-common/src/components/SafeHtml';
import SquareButton from '../../components/squareButton/SquareButton';
import classNames from 'classnames';
import { generateRoutePath } from '@epic-core/common';

const Character = ({data, active, mobileToggle, headwear, eyewear}) => {
    const [ activeSkin, setActiveSkin ] = useState(0);
    const { name, description, skins } = data;

    if (!skins || !skins[0]) return null;
    return (
        <div className={classNames('character', active && 'active', mobileToggle && 'toggled')}>
            <div className="character-info">
                <h1 className="character-name">{name}</h1>
                <ul className="character-skins">
                    {
                        skins.map((skin, index) => (
                            <li key={skin.name}>
                                <CharacterItem
                                    active={index === activeSkin}
                                    thumbnail={skin.images[0].thumbnail}
                                    name={skin.name}
                                    unlock={skin.unlock}
                                    description={skin.description}
                                    onClick={() => setActiveSkin(index)}
                                />
                            </li>
                        ))
                    }
                </ul>
                <h2 className="character-skin-name">{skins[activeSkin].name}</h2>
                <SafeHtml
                    element="p"
                    className="main-paragraph"
                    dangerouslySetInnerHTML={{ __html: description}} />
                <Link to={generateRoutePath('progression')}>
                    <SquareButton>
                        <Message code="epic.ut.character.view_progression_details" />
                    </SquareButton>
                </Link>
            </div>
            <div className="character-images">
                <img src={skins[activeSkin].images[0].image} alt={skins[activeSkin].name} />
                { eyewear && <img src={eyewear} alt="eyewear" /> }
                { headwear && <img src={headwear} alt="headwear" /> }
            </div>
        </div>
    )
}

Character.propTypes = {
    data: PropTypes.object,
    active: PropTypes.bool,
    mobileToggle: PropTypes.bool,
    headwear: PropTypes.string,
    eyewear: PropTypes.string
}

Character.defaultProps = {
    data: {},
    active: false,
    mobileToggle: false,
    headwear: null,
    eyewear: null
};

export default Character;
